<template>
  <div class="main-wrapper">
    <import-task ref="importTask">
      <template slot="header">
        <search-box class="search-box">
          <el-form :inline="true" size="mini">
            <el-form-item label="日期">
              <form-date-range
                :form="form"
                startKey="startDate"
                :usingTime="false"
                endKey="endDate"
                valueFormat="yyyy-MM-dd HH:mm:ss"
              ></form-date-range>
            </el-form-item>
          </el-form>
          <template v-slot:right>
            <el-button type="primary" size="small" @click="search">搜索</el-button>
            <el-button type="warning" size="small" @click="reset">重置</el-button>
          </template>
        </search-box>
      </template>
      <template slot="main-header">
        <el-button type="primary" size="mini" @click="dialogVisible = true">批量导入</el-button>
      </template>
    </import-task>

    <q-dialog
      :visible="dialogVisible"
      title="预销产品分类批量导入"
      width="600px"
      :inner-scroll="false"
      :loading="loading"
      @confirm="confirm"
      @cancel="cancel"
      @close="cancel"
    >
      <el-form ref="uploadForm" :model="uploadForm" :rules="rules" label-width="80px">
        <el-form-item label="文件" prop="file">
          <el-upload
            ref="upload"
            action="*"
            :auto-upload="false"
            :file-list="fileList"
            :limit="1"
            accept=".xls,.xlsx"
            :http-request="upload"
            :on-change="onFileChange"
            :on-remove="onRemove"
          >
            <el-button slot="trigger" type="primary" size="small">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: 'PrePlanClassifyImport',
  data() {
    return {
      loading: false,
      dialogVisible: false,
      fileList: [],
      form: {
        startDate: '',
        endDate: '',
        reportName: 'preSaleProductCategory',
      },
      uploadForm: {
        file: null,
      },
      rules: {
        file: [{ required: true, message: '请选择导入文件', trigger: 'change' }],
      },
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    search() {
      this.form.endDate = this.form.endDate ? this.form.endDate.substring(0, 10) + ' 23:59:59' : this.form.endDate;
      this.$refs.importTask.init(this.form);
    },
    reset() {
      this.form = {
        startDate: '',
        endDate: '',
        reportName: 'preSaleProductCategory',
      };
      this.search();
    },
    cancel() {
      this.dialogVisible = false;
      this.fileList = [];
      this.uploadForm.file = null;
    },
    onFileChange(file) {
      this.uploadForm.file = file.raw || file;
      this.fileList = [file];
      this.$refs.uploadForm.validateField('file');
    },
    onRemove() {
      this.fileList = [];
      this.uploadForm.file = null;
    },
    confirm() {
      this.$refs.uploadForm.validate((valid) => {
        if (!valid) return;
        this.$refs.upload.submit();
      });
    },
    upload({ file }) {
      let taskDTO=null;
      taskDTO = {
        reportName: 'preSaleProductCategory',
        appCode: "ec-pc-new",
        paramMap: [] 
      };
      this.loading = true;
      this.$q.common.uploadFile({
        data: {
          file,
          taskDTO: JSON.stringify(taskDTO)
        },
      }).then((res) => {
        if (res.success) {
          this.$message.success('数据导入中，请稍后');
          this.cancel();
          this.search();
        } else {
          this.$message.error(res.message || '导入失败');
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.main-wrapper
  height calc(100vh - 65px)

.search-box
  >>> .el-date-editor.el-input__inner
    width 110px
</style>
